<template>
  <div class="sider-consulting-container">
    <p class="customer-card">{{ text }}</p>
    <div class="divider" />
    <a class="btn" @click.prevent="contactUs"
      >{{ $t('liao-jie-qi-ye-fu-wu') }} <ArrowRight class="text-[18px]"
    /></a>
  </div>
</template>

<script setup lang="ts">
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
import { showDynamicContact } from '../utils/contact';

const props = withDefaults(
  defineProps<{
    text?: string;
  }>(),
  {},
);

const contactUs = () => {
  // 在这里添加您的联系逻辑
  console.log('联系我们被点击');
  // 例如：打开弹窗、跳转页面等
  // TODO 微信ID 文案
  showDynamicContact(1078922, '企业级数字人定制', '1V1专属咨询服务'); // @xi18n-ignore
};
</script>

<style lang="scss" scoped>
.sider-consulting-container {
  @apply sticky top-12 w-[320px] p-6 inline-flex items-center gap-6;
  align-self: flex-start;
  flex-direction: column;
  border-radius: 8px;
  background: var(--x-back-3);

  .customer-card {
    @apply my-0;
    color: var(--x-text-3);
    text-align: justify;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 175% */
  }
  .divider {
    width: 100%;
    height: 1px;
    background: var(--x-back-5);
  }
  .btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--x-purple-6);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    transition: color 0.3s;
    &:hover {
      color: var(--x-purple-8);
    }
  }
}
</style>
